import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, vModelText as _vModelText, vShow as _vShow, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex-lg-row-fluid mb-10 mb-lg-0 me-lg-7 me-xl-10" }
const _hoisted_2 = {
  class: "card pt-10 stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "penyediaanCalon",
  ref: "penyediaanCalon"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px\"><div class=\"stepper-nav ps-lg-10\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Kriteria Calon</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Pengesahan</h3><div class=\"stepper-desc\"></div></div></div></div></div>", 1)
const _hoisted_4 = { class: "flex-row-fluid py-lg-5 px-lg-15" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "row gx-10 mb-5" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Tetapan Kriteria")
], -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = ["checked"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "pemangkuan"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-center w-100" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder fs-4 mb-2" }, " Pemangkuan ")
  ])
], -1)
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "kenaikan"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-center w-100" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4" }, "Kenaikan Pangkat")
  ])
], -1)
const _hoisted_17 = { class: "mb-5" }
const _hoisted_18 = { class: "mb-2 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Skim Perkhidmatan & Gred", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, " Sila Pilih Jenis Pemangkuan ", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, " Sila Pilih Jenis Kenaikan Pangkat ", -1)
const _hoisted_23 = ["value", "onClick"]
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "mb-2 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tarikh Lantikan / Tarikh Kenaikan Pangkat / Pemangkuan ", -1)
const _hoisted_27 = { class: "row d-flex" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Mula", -1)
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Akhir", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1)
const _hoisted_33 = { class: "mb-5" }
const _hoisted_34 = { class: "mb-2 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tarikh Tempoh Permohonan", -1)
const _hoisted_36 = { class: "row d-flex" }
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label tooltext" }, "Tarikh Mula", -1)
const _hoisted_39 = {
  key: 0,
  "data-bs-toggle": "tooltip",
  title: "Permohonan Pemangkuan Badan ikhtisas Terbuka Sepanjang Tahun."
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "col-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Akhir", -1)
const _hoisted_43 = {
  key: 0,
  "data-bs-toggle": "tooltip",
  title: "Permohonan Pemangkuan Badan ikhtisas Terbuka Sepanjang Tahun."
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1)
const _hoisted_46 = { class: "mb-5" }
const _hoisted_47 = { class: "mb-2 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Markah LNPT", -1)
const _hoisted_49 = { class: "row d-flex" }
const _hoisted_50 = { class: "col-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tahun Mula", -1)
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tahun Akhir", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1)
const _hoisted_55 = { class: "mb-4 d-flex justify-content-between mt-5" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Lokasi Penempatan Khas", -1)
const _hoisted_57 = { class: "form-check form-switch form-switch-lg form-check-custom form-check-solid" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mx-2" }, "Tidak", -1)
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 1,
  class: "form-check-input",
  type: "checkbox",
  name: "sich",
  disabled: ""
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Ya", -1)
const _hoisted_62 = {
  key: 0,
  class: "bg-light-primary rounded border-primary border border-dashed p-6"
}
const _hoisted_63 = { class: "col-lg-12 mb-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5 me-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fv-row" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Negeri")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fv-row" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Daerah")
    ])
  ])
], -1)
const _hoisted_65 = { class: "col-lg-5 me-2" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Sila pilih negeri", -1)
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "col-lg-5 me-2" }
const _hoisted_70 = {
  key: 0,
  class: "col-lg-2"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  class: "d-flex",
  style: {"display":"none !important"}
}
const _hoisted_73 = { class: "col-lg-5 me-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Sila pilih negeri", -1)
const _hoisted_75 = ["value"]
const _hoisted_76 = { class: "col-lg-5" }
const _hoisted_77 = { class: "dropdown" }
const _hoisted_78 = { class: "input-group mb-3" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-group-append",
  style: {"position":"absolute","right":"10px","top":"50%","transform":"translateY(-50%)"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" })
  ])
], -1)
const _hoisted_80 = { class: "dropdown-menu show" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "col-lg-3 mx-2 d-flex" }
const _hoisted_83 = { class: "d-flex align-items-end" }
const _hoisted_84 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_85 = { class: "col-lg-5 me-2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Sila pilih negeri", -1)
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "col-lg-5" }
const _hoisted_89 = { class: "dropdown" }
const _hoisted_90 = { class: "input-group mb-3" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-group-append",
  style: {"position":"absolute","right":"10px","top":"50%","transform":"translateY(-50%)"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" })
  ])
], -1)
const _hoisted_92 = { class: "dropdown-menu show" }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = { class: "d-flex mt-5" }
const _hoisted_95 = { class: "mt-4 mb-4 d-flex justify-content-between" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Hantar notifikasi kepada calon apabila Permohonan dibuka", -1)
const _hoisted_97 = { class: "form-check form-switch form-switch-lg form-check-custom form-check-solid" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mx-2" }, "Tidak", -1)
const _hoisted_99 = ["disabled"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Ya", -1)
const _hoisted_101 = { "data-kt-stepper-element": "content" }
const _hoisted_102 = { class: "w-100" }
const _hoisted_103 = { class: "row gx-10 mb-5" }
const _hoisted_104 = { class: "col-lg-12" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "PENGESAHAN")
], -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tajuk Siri Kenaikan Pangkat / Pemangkuan", -1)
const _hoisted_108 = { class: "row mt-3 h-40px" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Kenaikan Pangkat bagi / Pemangkuan:")
], -1)
const _hoisted_110 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_111 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_113 = { class: "row mt-3 h-40px" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tarikh Tempoh Lantikan / Kenaikan Pangkat / Pemangkuan:")
], -1)
const _hoisted_115 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_116 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_118 = { class: "row mt-3 h-40px" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Bilangan Pegawai Layak:")
], -1)
const _hoisted_120 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_121 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#senarai_pegawai",
  class: "btn btn-success mx-2"
}, " Senarai ", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_124 = { class: "row mt-3 h-40px" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tempoh Permohonan:")
], -1)
const _hoisted_126 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_127 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_128 = {
  class: "badge badge-light border-success text-black mx-2",
  style: {"border":"2px solid"}
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_130 = { class: "row mt-3 h-40px" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Markah LNPT:")
], -1)
const _hoisted_132 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_133 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_135 = { class: "row mt-3 h-40px" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Lokasi Penempatan Khas:")
], -1)
const _hoisted_137 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_138 = {
  key: 0,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_139 = {
  key: 1,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_140 = {
  key: 0,
  class: "row mt-3 bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 mb-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "Negeri")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 mb-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "Daerah")
  ])
], -1)
const _hoisted_142 = { class: "d-flex justify-content-between" }
const _hoisted_143 = { class: "col-lg-6 mb-2" }
const _hoisted_144 = { class: "col-lg-6 mb-2" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_146 = { class: "row mt-3 h-40px" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hantar notifikasi kepada calon apabila Permohonan dibuka:")
], -1)
const _hoisted_148 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_149 = {
  key: 0,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_150 = {
  key: 1,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_152 = { class: "d-flex flex-stack pt-15" }
const _hoisted_153 = { class: "me-2" }
const _hoisted_154 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_155 = { class: "indicator-label" }
const _hoisted_156 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Sila Tunggu... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_158 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PenyediaanModal = _resolveComponent("PenyediaanModal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            class: "mx-auto w-100 pt-1",
            novalidate: "novalidate",
            id: "penyediaan_form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            name: "jenisType",
                            value: "pemangkuan",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (
                          (_ctx.tetapan = true),
                            (_ctx.targetData.kategori_permohonan = 'PMK')
                        )),
                            checked: _ctx.tetapan,
                            id: "pemangkuan"
                          }, null, 8, _hoisted_12),
                          _hoisted_13
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            name: "jenisType",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (
                          (_ctx.tetapan = false),
                            (_ctx.targetData.kategori_permohonan = 'KNP')
                        )),
                            id: "kenaikan",
                            checked: !_ctx.tetapan
                          }, null, 8, _hoisted_15),
                          _hoisted_16
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          (_ctx.tetapan == true)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.jenis_permohonan) = $event)),
                                class: "form-select mb-2"
                              }, [
                                _hoisted_20,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opsiSkimPemangkuan /*jenisDataPMK*/, (item, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: item.value
                                  }, _toDisplayString(item.label), 9, _hoisted_21))
                                }), 128))
                              ], 512)), [
                                [_vModelSelect, _ctx.targetData.jenis_permohonan]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.jenis_permohonan) = $event)),
                                class: "form-select mb-2"
                              }, [
                                _hoisted_22,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opsiSkimKenaikanPangkat /* jenisDataKNP*/, (item, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: item.value,
                                    onClick: ($event: any) => (
                            (_ctx.targetData.tajuk = item.tajuk),
                              (_ctx.targetData.jenis_label = item.label)
                          )
                                  }, _toDisplayString(item.label), 9, _hoisted_23))
                                }), 128))
                              ], 512)), [
                                [_vModelSelect, _ctx.targetData.jenis_permohonan]
                              ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _withDirectives(_createVNode(_component_datepicker, {
                                id: "tarikhKriteriaMula",
                                name: "tarikhKriteriaMula",
                                modelValue: _ctx.tarikhKriteria.mula,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tarikhKriteria.mula) = $event)),
                                placeholder: "DD-MM-YYYY",
                                textInput: "",
                                autoApply: "",
                                enableTimePicker: false,
                                maxDate: 
                              _ctx.tarikhKriteria.tamat
                                ? new Date(_ctx.tarikhKriteria.tamat)
                                : ''
                            ,
                                format: "dd-MM-yyyy"
                              }, null, 8, ["modelValue", "maxDate"]), [
                                [_directive_maska, '##-##-####']
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _withDirectives(_createVNode(_component_datepicker, {
                                id: "tarikhKriteriaTamat",
                                name: "tarikhKriteriaTamat",
                                modelValue: _ctx.tarikhKriteria.tamat,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tarikhKriteria.tamat) = $event)),
                                placeholder: "DD-MM-YYYY",
                                textInput: "",
                                autoApply: "",
                                enableTimePicker: false,
                                minDate: 
                              _ctx.tarikhKriteria.mula
                                ? new Date(_ctx.tarikhKriteria.mula)
                                : ''
                            ,
                                format: "dd-MM-yyyy"
                              }, null, 8, ["modelValue", "minDate"]), [
                                [_directive_maska, '##-##-####']
                              ])
                            ])
                          ]),
                          _hoisted_32
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _hoisted_38,
                              (_ctx.targetData.jenis_permohonan == 'IKHTISAS')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_39, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      name: "tarikhPermohonanMula",
                                      id: "tarikhPermohonanMula",
                                      modelValue: _ctx.tarikhPermohonan.mula,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tarikhPermohonan.mula) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: new Date(),
                                      maxDate: 
                                _ctx.tarikhPermohonan.tamat
                                  ? new Date(_ctx.tarikhPermohonan.tamat)
                                  : ''
                              ,
                                      format: "dd-MM-yyyy",
                                      disabled: true
                                    }, null, 8, ["modelValue", "minDate", "maxDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("i", _hoisted_40, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      name: "tarikhPermohonanMula",
                                      id: "tarikhPermohonanMula",
                                      modelValue: _ctx.tarikhPermohonan.mula,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tarikhPermohonan.mula) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: new Date(),
                                      maxDate: 
                                _ctx.tarikhPermohonan.tamat
                                  ? new Date(_ctx.tarikhPermohonan.tamat)
                                  : ''
                              ,
                                      format: "dd-MM-yyyy"
                                    }, null, 8, ["modelValue", "minDate", "maxDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              (_ctx.targetData.jenis_permohonan == 'IKHTISAS')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_43, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      id: "tarikhPermohonanTamat",
                                      name: "tarikhPermohonanTamat",
                                      modelValue: _ctx.tarikhPermohonan.tamat,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tarikhPermohonan.tamat) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: 
                                _ctx.tarikhPermohonan.mula
                                  ? new Date(_ctx.tarikhPermohonan.mula)
                                  : new Date()
                              ,
                                      format: "dd-MM-yyyy",
                                      disabled: true
                                    }, null, 8, ["modelValue", "minDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("i", _hoisted_44, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      id: "tarikhPermohonanTamat",
                                      name: "tarikhPermohonanTamat",
                                      modelValue: _ctx.tarikhPermohonan.tamat,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tarikhPermohonan.tamat) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: 
                                _ctx.tarikhPermohonan.mula
                                  ? new Date(_ctx.tarikhPermohonan.mula)
                                  : new Date()
                              ,
                                      format: "dd-MM-yyyy"
                                    }, null, 8, ["modelValue", "minDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                            ])
                          ]),
                          _hoisted_45
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _withDirectives(_createVNode(_component_datepicker, {
                                name: "markah_lnpt_tahun_mula",
                                id: "markah_lnpt_tahun_mula",
                                modelValue: _ctx.markah_lnpt.mula,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.markah_lnpt.mula) = $event)),
                                placeholder: "YYYY",
                                textInput: "",
                                autoApply: "",
                                yearPicker: "",
                                format: "yyyy",
                                maxDate: _ctx.maxDateForTahunMula(),
                                clearable: ""
                              }, null, 8, ["modelValue", "maxDate"]), [
                                [_directive_maska, '####']
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _hoisted_53,
                              _withDirectives(_createVNode(_component_datepicker, {
                                id: "markah_lnpt_tahun_akhir",
                                name: "markah_lnpt_tahun_akhir",
                                modelValue: _ctx.markah_lnpt.akhir,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.markah_lnpt.akhir) = $event)),
                                placeholder: "YYYY",
                                textInput: "",
                                autoApply: "",
                                yearPicker: "",
                                format: "yyyy",
                                maxDate: new Date(),
                                clearable: ""
                              }, null, 8, ["modelValue", "maxDate"]), [
                                [_directive_maska, '####']
                              ])
                            ])
                          ]),
                          _hoisted_54
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          (_ctx.tetapan == true)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                class: "form-check-input",
                                type: "checkbox",
                                value: "",
                                name: "sich",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => ((_ctx.lokasi = !_ctx.lokasi), _ctx.clearArray)),
                                disabled: 
                          _ctx.targetData.jenis_permohonan == 'IKHTISAS'
                            ? true
                            : false
                        
                              }, null, 8, _hoisted_59))
                            : (_openBlock(), _createElementBlock("input", _hoisted_60)),
                          _hoisted_61
                        ])
                      ]),
                      (_ctx.lokasi)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNegeriDaerah, (negeriDaerah, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex mb-2",
                                  key: negeriDaerah.key
                                }, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select",
                                      "onUpdate:modelValue": ($event: any) => ((negeriDaerah.negeri) = $event),
                                      "data-control": "select2"
                                    }, [
                                      _hoisted_67,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: index,
                                          value: item.value
                                        }, _toDisplayString(item.label), 9, _hoisted_68))
                                      }), 128))
                                    ], 8, _hoisted_66), [
                                      [_vModelSelect, negeriDaerah.negeri]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_69, [
                                    _createVNode(_component_VueSelect, {
                                      options: _ctx.optDaerahFilteredByNegeri(negeriDaerah.negeri),
                                      label: "nama_daerah",
                                      modelValue: negeriDaerah.daerah,
                                      "onUpdate:modelValue": ($event: any) => ((negeriDaerah.daerah) = $event),
                                      style: {}
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  (index > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                        _createElementVNode("button", {
                                          class: "btn btn-danger",
                                          onClick: ($event: any) => (_ctx.removeLokasiPenempatanField(negeriDaerah))
                                        }, " - ", 8, _hoisted_71)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedNegeri) = $event)),
                                    "data-control": "select2"
                                  }, [
                                    _hoisted_74,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: index,
                                        value: item.value
                                      }, _toDisplayString(item.label), 9, _hoisted_75))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.selectedNegeri]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_76, [
                                  _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("div", _hoisted_78, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchDaerah) = $event)),
                                        class: "form-control",
                                        placeholder: "Taip Daerah",
                                        onFocus: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
                                        onInput: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        style: {"padding-right":"30px"}
                                      }, null, 544), [
                                        [_vModelText, _ctx.searchDaerah]
                                      ]),
                                      _hoisted_79
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "hidden",
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedDaerah) = $event)),
                                      name: "daerah"
                                    }, null, 512), [
                                      [_vModelText, _ctx.selectedDaerah]
                                    ]),
                                    _withDirectives(_createElementVNode("div", _hoisted_80, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDaerah, (item) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                          class: "dropdown-item",
                                          key: item.id,
                                          onClick: ($event: any) => (_ctx.selectDaerah(item))
                                        }, _toDisplayString(item.nama_daerah), 9, _hoisted_81))
                                      }), 128))
                                    ], 512), [
                                      [_vShow, _ctx.state.isOpen && _ctx.filteredDaerah.length > 0]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("span", _hoisted_83, [
                                  (_ctx.total >= 2)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.removeItem(_ctx.index)), ["stop"])),
                                        class: "btn btn-danger"
                                      }, " - "))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.secondDropdownIsOpen)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-select",
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedNegeri2) = $event)),
                                        "data-control": "select2"
                                      }, [
                                        _hoisted_86,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: index,
                                            value: item.value
                                          }, _toDisplayString(item.label), 9, _hoisted_87))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _ctx.selectedNegeri2]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_88, [
                                      _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("div", _hoisted_90, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.searchDaerah2) = $event)),
                                            class: "form-control",
                                            placeholder: "Taip Daerah",
                                            onFocus: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.handleFocus2 && _ctx.handleFocus2(...args))),
                                            onInput: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleInput2 && _ctx.handleInput2(...args))),
                                            style: {"padding-right":"30px"}
                                          }, null, 544), [
                                            [_vModelText, _ctx.searchDaerah2]
                                          ]),
                                          _hoisted_91
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "hidden",
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedDaerah2) = $event)),
                                          name: "daerah2"
                                        }, null, 512), [
                                          [_vModelText, _ctx.selectedDaerah2]
                                        ]),
                                        _withDirectives(_createElementVNode("div", _hoisted_92, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDaerah2, (item) => {
                                            return (_openBlock(), _createElementBlock("a", {
                                              class: "dropdown-item",
                                              key: item.id,
                                              onClick: ($event: any) => (_ctx.selectDaerah2(item))
                                            }, _toDisplayString(item.nama_daerah), 9, _hoisted_93))
                                          }), 128))
                                        ], 512), [
                                          [_vShow, 
                                _ctx.state2.isOpen && _ctx.filteredDaerah2.length > 0
                              ]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("a", {
                                  onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (
                            /*displaySecondDropdown*/ _ctx.addLokasiPenempatanField()
                          ), ["stop"])),
                                  class: "btn btn-primary",
                                  style: {"margin-right":"0.5rem"}
                                }, " Add Item ")
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _createElementVNode("div", _hoisted_97, [
                          _hoisted_98,
                          _createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: "",
                            name: "hantarNotifikasi",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.notifikasi = !_ctx.notifikasi)),
                            disabled: 
                          _ctx.targetData.jenis_permohonan == 'IKHTISAS' ||
                          _ctx.targetData.jenis_permohonan == 'PRO'
                            ? true
                            : false
                        
                          }, null, 8, _hoisted_99),
                          _hoisted_100
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      _hoisted_105,
                      _hoisted_106,
                      _hoisted_107,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "tajuk",
                        class: "form-control mb-2",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.targetData.tajuk) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.targetData.tajuk]
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _hoisted_109,
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.targetData.jenis_label), 1)
                        ])
                      ]),
                      _hoisted_112,
                      _createElementVNode("div", _hoisted_113, [
                        _hoisted_114,
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.formatDate(_ctx.tarikhKriteria.mula)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.tarikhKriteria.tamat)), 1)
                        ])
                      ]),
                      _hoisted_117,
                      _createElementVNode("div", _hoisted_118, [
                        _hoisted_119,
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("span", _hoisted_121, _toDisplayString(_ctx.calonList.length), 1),
                          _hoisted_122
                        ])
                      ]),
                      _hoisted_123,
                      _createElementVNode("div", _hoisted_124, [
                        _hoisted_125,
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.formatDate(_ctx.tarikhPermohonan.mula)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.tarikhPermohonan.tamat)), 1),
                          _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.dateDiff), 1)
                        ])
                      ]),
                      _hoisted_129,
                      _createElementVNode("div", _hoisted_130, [
                        _hoisted_131,
                        _createElementVNode("div", _hoisted_132, [
                          _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.markah_lnpt.mula) + " - " + _toDisplayString(_ctx.markah_lnpt.akhir), 1)
                        ])
                      ]),
                      _hoisted_134,
                      _createElementVNode("div", _hoisted_135, [
                        _hoisted_136,
                        _createElementVNode("div", _hoisted_137, [
                          (_ctx.lokasi)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_138, "Ya"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_139, "Tidak"))
                        ])
                      ]),
                      (_ctx.lokasi)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                            _hoisted_141,
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("div", _hoisted_143, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNegeriDaerah, (negeriDaerah, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "mb-2",
                                    key: negeriDaerah.key
                                  }, [
                                    _createElementVNode("span", null, "Negeri " + _toDisplayString(index + 1) + ": " + _toDisplayString(_ctx.findLabel(negeriDaerah.negeri, _ctx.combo.negeri)), 1)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_144, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNegeriDaerah, (negeriDaerah, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "mb-2",
                                    key: negeriDaerah.key
                                  }, [
                                    _createElementVNode("span", null, "Daerah " + _toDisplayString(1 + index) + ": " + _toDisplayString(negeriDaerah.daerah.nama_daerah || ""), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_145,
                      _createElementVNode("div", _hoisted_146, [
                        _hoisted_147,
                        _createElementVNode("div", _hoisted_148, [
                          (_ctx.notifikasi)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_149, "Ya"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_150, "Tidak"))
                        ])
                      ]),
                      _hoisted_151
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_152, [
                _createElementVNode("div", _hoisted_153, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createElementVNode("span", _hoisted_154, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr063.svg" })
                    ]),
                    _createTextVNode(" Sebelum ")
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-lg btn-primary mb-5",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.formSubmit()))
                      }, [
                        _createElementVNode("span", _hoisted_155, [
                          _createTextVNode(" Simpan "),
                          _createElementVNode("span", _hoisted_156, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        _hoisted_157
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args))),
                        class: "btn btn-lg btn-primary mb-5"
                      }, [
                        _createTextVNode(" Seterusnya "),
                        _createElementVNode("span", _hoisted_158, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                ])
              ])
            ]),
            _: 1
          })
        ])
      ], 512)
    ]),
    _createVNode(_component_PenyediaanModal, { calonData: _ctx.calonList }, null, 8, ["calonData"])
  ], 64))
}